<template>
  <div class="illustration-container">
    <div class="header-section">
      <h1>{{ illustration.title }}</h1>
      <p class="subtitle">{{ illustration.subtitle }}</p>
    </div>
    
    <div class="projects-grid">
      <div class="column">
        <div v-for="project in oddProjects" :key="project.id" class="project-card">
          <div class="artwork-display">
            <a :href="project.image" class="image-popup">
              <img :src="project.image" :alt="project.alt" :style="{ objectPosition: project.objectPosition || 'center' }">
            </a>
            <div class="artwork-overlay">
              <div class="zoom-button" @click="openPopup(project.image)">
                <i class="fas fa-search-plus"></i>
              </div>
            </div>
          </div>
          <div class="project-info">
            <h3>{{ project.title }}</h3>
            <p>{{ project.description }}</p>
            <div class="tech-stack">
              <span v-for="tech in project.techStack" :key="tech">{{ tech }}</span>
            </div>
            <div class="project-details">
              <div class="detail-item">
                <span class="label">Client:</span>
                <span class="value">{{ project.client }}</span>
              </div>
              <div class="detail-item">
                <span class="label">Year:</span>
                <span class="value">{{ project.year }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div v-for="project in evenProjects" :key="project.id" class="project-card">
          <div class="artwork-display">
            <a :href="project.image" class="image-popup">
              <img :src="project.image" :alt="project.alt" :style="{ objectPosition: project.objectPosition || 'center' }">
            </a>
            <div class="artwork-overlay">
              <div class="zoom-button" @click="openPopup(project.image)">
                <i class="fas fa-search-plus"></i>
              </div>
            </div>
          </div>
          <div class="project-info">
            <h3>{{ project.title }}</h3>
            <p>{{ project.description }}</p>
            <div class="tech-stack">
              <span v-for="tech in project.techStack" :key="tech">{{ tech }}</span>
            </div>
            <div class="project-details">
              <div class="detail-item">
                <span class="label">Client:</span>
                <span class="value">{{ project.client }}</span>
              </div>
              <div class="detail-item">
                <span class="label">Year:</span>
                <span class="value">{{ project.year }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <HomeButton />
</template>

<script>
import $ from 'jquery'
import 'magnific-popup/dist/jquery.magnific-popup.js'
import 'magnific-popup/dist/magnific-popup.css'
import '@fortawesome/fontawesome-free/css/all.css'
import HomeButton from '@/components/common/HomeButton.vue'

export default {
  name: 'PortfolioIllustration',
  components: {
    HomeButton
  },
  data() {
    return {
      illustration: {
        title: "Illustration",
        subtitle: "Digital Art & Creative Expression",
        projects: [
          {
            id: 1,
            image: require('@/assets/img/illustrator/15.jpg'),
            alt: "Illustration",
            title: "Illustration",
            description: "",
            techStack: ["Adobe Photoshop", "Clip studio paint"],
            client: "",
            style: "Digital Art",
            category: "Illustration",
            year: "2025",
            objectPosition: "top"
          },
          {
            id: 2,
            image: require('@/assets/img/illustrator/00.png'),
            alt: "Drama troupe poster",
            title: "Drama troupe poster",
            description: "A poster designed for a drama troupe, visually presenting character relationships while capturing audience attention through compelling composition and illustration.",
            techStack: ["Adobe Photoshop", "Adobe Illustrator", "Clip studio paint"],
            client: "Drama troupe",
            style: "Digital Art",
            category: "Poster",
            year: "2021"
          },
          {
            id: 3,
            image: require('@/assets/img/illustrator/09.png'),
            alt: "Fan illustrations",
            title: "Fan illustrations",
            description: "Illustrations and costume designs created for a fan comic exhibition.",
            techStack: ["Adobe Photoshop", "Adobe Illustrator", "Clip studio paint"],
            client: "Doujinshi Exhibition",
            style: "Digital Art",
            category: "Illustration",
            year: "2023"
          },
          {
            id: 4,
            image: require('@/assets/img/illustrator/06.jpg'),
            alt: "Character design",
            title: "Character design",
            description: "Character and illustration design for a VTuber, aiming to portray a personality that is both laid-back and lively.",
            techStack: ["Adobe Photoshop", "Clip studio paint"],
            client: "Vtuber",
            style: "Digital Art",
            category: "Character design",
            year: "2022"
          },
          {
            id: 5,
            image: require('@/assets/img/illustrator/10.png'),
            alt: "Fan illustrations",
            title: "Fan illustrations",
            description: "Illustrations and costume designs created for a fan comic exhibition.",
            techStack: ["Adobe Photoshop", "Adobe Illustrator", "Clip studio paint"],
            client: "Doujinshi Exhibition",
            style: "Digital Art",
            category: "Illustration clothes",
            year: "2023"
          },
          {
            id: 6,
            image: require('@/assets/img/illustrator/14.jpg'),  
            alt: "Youtube illustration",
            title: "Youtube illustration",
            description: "Character and illustration design for a VTuber, aiming to portray a personality that is both laid-back and lively.",
            techStack: ["Adobe Photoshop", "Clip studio paint"],
            client: "Vtuber",
            style: "Digital Art",
            category: "Illustration",
            year: "2022"
          },
          {
            id: 7,  
            image: require('@/assets/img/illustrator/02.jpg'),
            alt: "Character design",
            title: "Character design",
            description: "Designed a Halloween outfit for an existing character, aiming to highlight their mischievous and devilish side.",
            techStack: ["Adobe Photoshop", "Clip studio paint"],
            client: "Social Game",
            style: "Digital Art",
            category: "Character design",
            year: "2023"
          },
          {
            id: 8,
            image: require('@/assets/img/illustrator/11.jpg'),
            alt: "Character design",
            title: "Character design",
            description: "Designed some mascots to create a sense of closeness between the brand and customers, also aiming to help people remember the brand through the characters.",
            client: "Website Mascot",
            style: "Digital Art",
            category: "Character design",
            year: "2023"
          },
          {
            id: 9,
            image: require('@/assets/img/illustrator/13.jpg'),
            alt: "Character design",
            title: "Character design",
            description: "A concept project featuring four characters, each designed based on a different MBTI personality type, inspired by the unique stories and traits of my friends.",
            techStack: ["Adobe Photoshop", "Clip studio paint"],
            client: "Original Character",
            style: "Digital Art",
            category: "Character design",
            year: "2025"
          },
          {
            id: 10,
            image: require('@/assets/img/illustrator/08.jpg'),
            alt: "Commercial illustration draft",
            title: "Commercial illustration draft",
            description: "Draft illustration for OMEN PC's promotional sales at Don Quijote in Japan",
            techStack: ["Adobe Photoshop", "Clip studio paint"],
            client: "OMEN",
            style: "Digital Art",
            category: "Illustration",
            year: "2023"
          }
        ]
      }
    }
  },
  computed: {
    sortedProjects() {
      return [...this.illustration.projects].sort((a, b) => a.id - b.id);
    },
    oddProjects() {
      return this.sortedProjects.filter(project => project.id % 2 === 1);
    },
    evenProjects() {
      return this.sortedProjects.filter(project => project.id % 2 === 0);
    }
  },
  mounted() {
    this.$nextTick(() => {
      $('.image-popup').magnificPopup({
        type: 'image',
        closeOnContentClick: true,
        closeBtnInside: false,
        fixedContentPos: true,
        mainClass: 'mfp-no-margins mfp-with-zoom',
        image: {
          verticalFit: true
        },
        zoom: {
          enabled: true,
          duration: 300
        },
        callbacks: {
          open: function() {
            history.pushState({ popup: true }, '');
          },
          close: function() {
            if (history.state && history.state.popup) {
              history.back();
            }
          }
        }
      });

      window.addEventListener('popstate', this.handlePopState);
    });
  },
  beforeUnmount() {
    window.removeEventListener('popstate', this.handlePopState);
  },
  methods: {
    openPopup(imageUrl) {
      const $link = $('.image-popup').first();
      $link.attr('href', imageUrl);
      $link.trigger('click');
    },
    handlePopState() {
      if ($.magnificPopup.instance.isOpen) {
        $.magnificPopup.close();
      }
    }
  }
}
</script>

<style scoped>
.illustration-container {
  padding: 2rem 1rem;
  max-width: 1200px;
  margin: 0 auto;
}

.header-section {
  text-align: center;
  margin-bottom: 2rem;
}

.header-section h1 {
  font-size: 2.5rem;
  color: #fff;
  margin-bottom: 1rem;
}

.subtitle {
  font-size: 1.1rem;
  color: #666;
}

.projects-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  padding: 0.5rem;
}

@media (max-width: 992px) {
  .header-section h1 {
    font-size: 2.2rem;
  }
  
  .subtitle {
    font-size: 1rem;
  }
}

@media (max-width: 768px) {
  .projects-grid {
    grid-template-columns: 1fr;
    padding: 0;
  }
  
  .illustration-container {
    padding: 1rem 0.5rem;
  }
  
  .header-section {
    margin-bottom: 1.5rem;
  }
  
  .header-section h1 {
    font-size: 2rem;
  }
}

@media (max-width: 576px) {
  .header-section h1 {
    font-size: 1.8rem;
  }
  
  .subtitle {
    font-size: 0.9rem;
  }
  
  .project-info h3 {
    font-size: 1.2rem;
  }
  
  .project-info p {
    font-size: 0.9rem;
    line-height: 1.4;
  }
  
  .tech-stack span {
    font-size: 0.8rem;
    padding: 0.2rem 0.6rem;
  }
  
  .label {
    font-size: 0.8rem;
  }
  
  .value {
    font-size: 0.9rem;
  }
  
  .zoom-button {
    width: 40px;
    height: 40px;
  }
}

.project-card {
  break-inside: avoid;
  margin-bottom: 1.5rem;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  width: 100%;
}

.project-card:hover {
  transform: translateY(-5px);
}

.artwork-display {
  position: relative;
  overflow: hidden;
}

.artwork-display img {
  width: 100%;
  height: auto;
  display: block;
  transition: transform 0.3s ease;
  aspect-ratio: 16/9;
  object-fit: cover;
}

.artwork-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: opacity 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.artwork-display:hover .artwork-overlay {
  opacity: 1;
}

.zoom-button {
  width: 50px;
  height: 50px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 10;
}

.zoom-button:hover {
  background: white;
  transform: scale(1.1);
}

.zoom-button i {
  color: #333;
  font-size: 1.2rem;
}

.project-info {
  padding: 1.5rem;
}

.project-info h3 {
  color: #333;
  margin-bottom: 0.5rem;
}

.project-info p {
  color: #666;
  margin-bottom: 1rem;
}

.tech-stack {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}

.tech-stack span {
  background: #f0f0f0;
  padding: 0.3rem 0.8rem;
  border-radius: 15px;
  font-size: 0.9rem;
  color: #555;
}

.project-details {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #eee;
}

.detail-item {
  display: flex;
  flex-direction: column;
}

.label {
  font-size: 0.9rem;
  color: #666;
}

.value {
  font-weight: 500;
  color: #333;
}

/* 触摸设备优化 */
@media (hover: none) {
  .artwork-overlay {
    opacity: 1;
    background: rgba(0, 0, 0, 0.3);
  }
  
  .project-card:active {
    transform: translateY(-5px);
  }
}
</style> 